<template>
  <y-block-box title="下载点击量">
    <div class="main-box">
      <div style="flex: 1;overflow:auto;padding: 0px 16px;">
        <el-table :data="tableData" v-loading="loadingData" style="width: 100%" empty-text='暂无数据'>
          <!-- 拓展信息 -->
          <el-table-column type="expand" width="48">
            <template slot-scope="props">
              <div class="expand-contain">
                <div style="grid-column-start: span 2;font-weight: bold;">
                  用户信息
                </div>
                <div class="title">IP</div>
                <div class="label">{{ props.row.client_ip }}</div>
                <div class="title">客户端</div>
                <div class="label">{{ props.row.user_agent }}</div>
                <div style="grid-column-start: span 2;font-weight: bold;">
                  点击版本
                </div>
                <div class="title">平台架构</div>
                <div class="label">{{ props.row.data.plat }} -{{ props.row.data.arch }}</div>
                <div class="title">格式</div>
                <div class="label">{{ props.row.data.format }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="client_ip" label="IP" width="120px" sortable></el-table-column>
          <el-table-column prop="user_agent" label="客户端" sortable>
            <template slot-scope="scope">
              <div style="font-size:10px">
                {{ scope.row.user_agent }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="data.plat" label="平台" width="80px" sortable></el-table-column>
          <el-table-column prop="data.arch" label="架构" width="80px" sortable></el-table-column>
          <el-table-column prop="data.prerelease" label="预发布" width="100px" sortable></el-table-column>
          <el-table-column prop="data.format" label="格式" width="80px" sortable></el-table-column>
          <el-table-column prop="createdAtLocal" label="创建时间" width="200px" sortable>
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              {{ new Date(scope.row.createdAt).toLocaleString() }}
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div style="display: flex;justify-content: right;padding: 0px 16px;">
        <el-pagination @size-change="fnQuery" @current-change="fnQuery" :current-page.sync="currentPage"
                       :page-sizes="[10, 50, 100, 500, 1000, 10000]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="tableTotal">
        </el-pagination>
      </div>
    </div>
  </y-block-box>
</template>


<script>
export default {
  name: 'index',
  props: {},
  data() {
    return {
      pageSize: 10,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      templateEditVisible: false,
      editType: '',
      loadingData: false
    }
  },
  mounted() {
    this.fnQuery()
  },
  methods: {
    async fnQuery() {
      this.loadingData = true
      this.$callApi("queryClickData", {
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }, { method: "post" }).then(res => {
        this.tableData = res.list.map((i) => {
          let date = new Date(i.createdAt);
          date.setMilliseconds(date.getMilliseconds() + 8 * 3600e3);
          i.createdAtLocal = date.toISOString();
          return i;
        });
        this.tableTotal = res.total
        this.loadingData = false;
      })
        .catch(e => {
          this.$message.error(e.message || "请求失败");
          this.loadingData = false;
        });
    }
  },
}
</script>
<style lang="less" scoped>
.main-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  height: 100%;
}

.expand-contain {
  display: grid;
  grid-template-columns: 80px 1fr;
  margin-left: 48px;

  div {
    line-height: 40px;
  }

  .title {
    color: #99a9bf;
  }

  .title::after {
    content: '：';
  }

  .label:empty::after {
    content: '--';
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/clickdata/clickdata.vue